import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [content, setContent] = useState({}); // { branches_sl: [...], branches_eu: [...], ... }
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [s, c] = await Promise.all([
        axios.get(`${API}/settings`),
        axios.get(`${API}/content`),
      ]);
      setSettings(s.data);
      setContent(c.data || {});
    } catch (e) {
      setSettings({ site_status: 'public' });
      setContent({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // getContent returns admin-managed list if present, else the provided fallback array.
  const getContent = useCallback((key, fallback) => {
    const val = content[key];
    if (Array.isArray(val) && val.length > 0) return val;
    return fallback;
  }, [content]);

  return (
    <SiteSettingsContext.Provider value={{ settings: settings || {}, content, loading, refresh, setSettings, getContent }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) throw new Error('useSiteSettings must be used inside SiteSettingsProvider');
  return ctx;
};
